"use client"

import { useState, useEffect } from "react"
import { useFrame, useLoader } from "@react-three/fiber"
import * as THREE from "three"

export function useAnimatedTexture(textureUrl: string) {
  const [animationData, setAnimationData] = useState<any>(null)
  const texture = useLoader(THREE.TextureLoader, textureUrl)

  useEffect(() => {
    const fetchAnimationData = async () => {
      try {
        const response = await fetch(`${textureUrl}.mcmeta`)
        if (response.ok) {
          const data = await response.json()
          setAnimationData(data.animation)
        }
      } catch (error) {
        // No mcmeta file, not an animated texture
      }
    }
    fetchAnimationData()
  }, [textureUrl])

  useFrame((state, delta) => {
    if (animationData && texture) {
      const { frames, frametime = 1 } = animationData
      const frameCount = frames.length
      const totalTime = frameCount * frametime
      const currentTime = state.clock.getElapsedTime()
      const currentFrameIndex = Math.floor((currentTime / totalTime) * frameCount) % frameCount
      const currentFrame = frames[currentFrameIndex]

      if (typeof currentFrame === "number") {
        texture.offset.y = 1 - (currentFrame + 1) / frameCount
        texture.repeat.y = 1 / frameCount
      }
    }
  })

  return texture
}
